// Função para gerar horários
const generateTimeSlots = (start, end, interval, date, barbershopId) => {
  const slots = [];
  let currentTime = new Date(`${date}T${start}:00`);
  const endTime = new Date(`${date}T${end}:00`);
  let id = 1;

  while (currentTime < endTime) {
    slots.push({
      id: `${barbershopId}-slot-${id++}`,
      barbershopId: barbershopId,
      date: date,
      time: currentTime.toTimeString().substring(0, 5), // Formato HH:MM
      isBooked: false,
      clientName: null,
      service: null,
    });
    currentTime.setMinutes(currentTime.getMinutes() + interval);
  }
  return slots;
};

// Gerar datas para os próximos 30 dias
const getNext30Days = () => {
  const dates = [];
  const today = new Date();
  for (let i = 0; i < 30; i++) {
    const nextDay = new Date(today);
    nextDay.setDate(today.getDate() + i);
    dates.push(nextDay.toISOString().split('T')[0]); // Formato YYYY-MM-DD
  }
  return dates;
};

const MOCK_DATA = {
  users: {
    user: { id: 'u1', name: 'Cliente Frequente', role: 'user' },
    owner: { id: 'o1', name: 'Dono Barbearia', role: 'owner', barbershopId: 'b1' },
    admin: { id: 'a1', name: 'Admin', role: 'admin' },
  },
  barbershops: [
    {
      id: 'b1',
      name: 'Barbearia Premium',
      description: 'Mais do que uma barbearia, uma experiência. Cortes clássicos e modernos com os melhores profissionais da cidade.',
      bannerUrl: 'https://placehold.co/1200x400/1a1a1a/ffffff?text=Barbearia+Premium',
      isSponsored: true,
      city: 'São Paulo',
      rating: 4.9,
      address: 'Rua Augusta, 1234 - Consolação',
      phone: '(11) 98765-4321',
      services: [
        { name: 'Corte Masculino', price: 45, duration: '30 min' },
        { name: 'Barba', price: 35, duration: '20 min' },
        { name: 'Corte + Barba', price: 70, duration: '50 min' },
        { name: 'Degradê', price: 50, duration: '40 min' },
        { name: 'Sobrancelha', price: 15, duration: '10 min' },
      ],
      barbers: [
        { name: 'Roberto Silva', specialty: 'Cortes Clássicos', experience: '15 anos' },
        { name: 'Carlos Mendes', specialty: 'Degradê e Modernos', experience: '8 anos' },
      ],
    },
    {
      id: 'b2',
      name: 'Navalha de Ouro',
      description: 'Tradição e qualidade desde 1980. Venha para um corte e saia com um amigo.',
      bannerUrl: 'https://placehold.co/1200x400/333333/ffffff?text=Navalha+de+Ouro',
      isSponsored: true,
      city: 'Rio de Janeiro',
      rating: 4.8,
      address: 'Av. Atlântica, 567 - Copacabana',
      phone: '(21) 99876-5432',
      services: [
        { name: 'Corte Tradicional', price: 40, duration: '30 min' },
        { name: 'Barba Completa', price: 30, duration: '25 min' },
        { name: 'Pacote Completo', price: 65, duration: '55 min' },
        { name: 'Relaxamento Capilar', price: 80, duration: '1h' },
      ],
      barbers: [
        { name: 'José Antonio', specialty: 'Cortes Tradicionais', experience: '30 anos' },
        { name: 'Pedro Santos', specialty: 'Barbas e Bigodes', experience: '12 anos' },
        { name: 'Lucas Oliveira', specialty: 'Penteados', experience: '5 anos' },
      ],
    },
    {
      id: 'b3',
      name: 'The Modern Barber',
      description: 'Estilo urbano, cortes na régua e os melhores produtos para sua barba.',
      bannerUrl: 'https://placehold.co/1200x400/222222/ffffff?text=The+Modern+Barber',
      isSponsored: false,
      city: 'São Paulo',
      rating: 4.7,
      address: 'Rua Oscar Freire, 890 - Jardins',
      phone: '(11) 97654-3210',
      services: [
        { name: 'Corte Moderno', price: 55, duration: '40 min' },
        { name: 'Barba Estilizada', price: 40, duration: '30 min' },
        { name: 'Design de Barba', price: 60, duration: '45 min' },
        { name: 'Corte + Barba Premium', price: 85, duration: '1h 10min' },
        { name: 'Coloração', price: 120, duration: '1h 30min' },
      ],
      barbers: [
        { name: 'Thiago Costa', specialty: 'Cortes Modernos', experience: '10 anos' },
        { name: 'Rafael Lima', specialty: 'Barbas Estilizadas', experience: '7 anos' },
      ],
    },
    {
      id: 'b4',
      name: 'Corte & Cia',
      description: 'Ambiente familiar e profissionalismo. O seu visual em boas mãos.',
      bannerUrl: 'https://placehold.co/1200x400/111111/ffffff?text=Corte+e+Cia',
      isSponsored: false,
      city: 'Belo Horizonte',
      rating: 4.6,
      address: 'Av. Afonso Pena, 1500 - Centro',
      phone: '(31) 98234-5678',
      services: [
        { name: 'Corte Simples', price: 35, duration: '25 min' },
        { name: 'Barba', price: 25, duration: '20 min' },
        { name: 'Corte + Barba', price: 55, duration: '45 min' },
        { name: 'Infantil', price: 30, duration: '20 min' },
      ],
      barbers: [
        { name: 'João Ferreira', specialty: 'Cortes Familiares', experience: '20 anos' },
        { name: 'Marcos Paulo', specialty: 'Infantil', experience: '8 anos' },
      ],
    },
  ],
  availableSlots: [
    ...getNext30Days().flatMap(date => 
      generateTimeSlots('09:00', '18:00', 45, date, 'b1')
    ),
    ...getNext30Days().flatMap(date => 
      generateTimeSlots('10:00', '20:00', 60, date, 'b2')
    ),
    ...getNext30Days().flatMap(date => 
      generateTimeSlots('08:00', '17:00', 30, date, 'b3')
    ),
    ...getNext30Days().flatMap(date => 
      generateTimeSlots('09:00', '18:00', 60, date, 'b4')
    ),
  ],
  appointments: [
    {
      id: 'a1',
      userId: 'u1',
      barbershopId: 'b1',
      slotId: 'b1-slot-5',
      date: getNext30Days()[1], // Amanhã
      time: '10:30',
      service: 'Cabelo + Barba',
      clientName: 'Cliente Frequente',
      phone: '11987654321',
      status: 'pending', // 'pending', 'confirmed', 'completed', 'cancelled'
    },
    {
      id: 'a2',
      userId: 'u1',
      barbershopId: 'b3',
      slotId: 'b3-slot-10',
      date: getNext30Days()[3], // Em 3 dias
      time: '14:00',
      service: 'Cabelo',
      clientName: 'Cliente Frequente',
      phone: '11987654321',
      status: 'confirmed',
    },
    {
      id: 'a3',
      userId: 'u1',
      barbershopId: 'b2',
      slotId: 'b2-slot-2',
      date: '2023-10-20', // Passado
      time: '11:00',
      service: 'Barba',
      clientName: 'Cliente Frequente',
      phone: '11987654321',
      status: 'completed',
    },
  ],
};

export { getNext30Days, generateTimeSlots };
export default MOCK_DATA;
